module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-group border-top-lg border-top-primary"
  }, [_c('div', {
    staticClass: "page-header page-header-default page-header-xs",
    staticStyle: {
      "border-left": "1px solid #ddd",
      "border-right": "1px solid #ddd"
    }
  }, [_c('div', {
    staticClass: "page-header-content"
  }, [(_vm.isBlogOfLinks) ? _c('div', {
    staticClass: "page-title"
  }, [_c('h5', [_c('span', {
    staticClass: "text-semibold"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "hidden-xs"
  }, [_c('img', {
    attrs: {
      "src": "/assets/img/logo.png",
      "height": "18px"
    }
  }), _vm._v(" - ")]), _vm._v("Small pieces of the Internet")]), (_vm.loggedIn) ? _c('small', [_vm._v("by " + _vm._s(_vm.getUser.email) + " ")]) : _vm._e()], 1)])]) : _c('div', {
    staticClass: "page-title pb-logo"
  }, [_c('h5', [_c('span', {
    staticClass: "text-semibold"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "hidden-xs"
  }, [_c('img', {
    attrs: {
      "src": "/assets/img/pb_logo.png",
      "height": "40px"
    }
  })])]), (_vm.loggedIn) ? _c('small', [_vm._v("by " + _vm._s(_vm.getUser.email) + " ")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "heading-elements"
  }, [_c('div', {
    staticClass: "btn-group heading-btn"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [(_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateMode($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gamepad pull-right"
  }), _vm._v(" Mode | "), _c('b', [_vm._v(_vm._s(_vm.mode))])])]) : _vm._e(), _vm._v(" "), (_vm.isBlogOfLinks) ? _c('li', [_vm._m(1)]) : _c('li', [_vm._m(2)]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_c('i', {
    staticClass: "fa fa-user pull-right"
  }), _vm._v(" About me")])], 1), _vm._v(" "), (!_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleModal($event)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-sign-in-alt pull-right"
  }), _vm._v(" Login")])]) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout($event)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-sign-out-alt pull-right"
  }), _vm._v(" Logout")])]) : _vm._e()])])])])]), _vm._v(" "), _c('login-modal', {
    attrs: {
      "showModal": _vm.showModal,
      "toggleModal": _vm.toggleModal
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-link btn-icon heading-btn dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-cog hidden-xs"
  }), _c('span', {
    staticClass: "visible-xs"
  }, [_vm._v("Open menu")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://andreihirvi.com",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fas fa-book pull-right"
  }), _vm._v(" Blog")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://www.andrew.ooo",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fas fa-link pull-right"
  }), _vm._v(" Blog of links")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef5c2622","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 370
// module chunks = 0